import { graphql } from '@/client/services/api/graphql/gql';

export const activeAnnouncementsQuery = graphql(`
  query ActiveAppAnnouncements($route: String!) {
    activeAppAnnouncements(route: $route) {
      id
      content
      translations {
        languageCode
        content
      }
    }
  }
`);
